import request from '@/utils/request'

// 常量
const api_name = '/app/categories'

export default {
    // 列表
    getCategoriesAndTagCount() {
        return request({
            // 接口路径
            url: `${api_name}/getCategoriesAndTagCount`,
            method: 'get'
        })
    },
    getCategories() {
        return request({
            // 接口路径
            url: `${api_name}/getCategories`,
            method: 'get'
        })
    }
}